import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * This preloading strategy automatically preloads all lazy-loaded routing
 * modules, which have `preload: true` set in their config data.
 */
@Injectable({
  providedIn: 'root'
})
export class AppRoutePreloadingStrategy implements PreloadingStrategy {
  public preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    return route.data?.preload ? load() : of(null);
  }
}
